<template>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="suggestion"
                fab text
                small
                absolute
                right
                bottom
                class="mb-6"
                v-bind="attrs"
                v-on="on">
                <v-icon>contact_page</v-icon>
            </v-btn>
        </template>
        <div class="caption font-italic">
            Creato <span v-if="created_by"> da <span v-if="created_by" class="font-bold">{{ $store.state.users[created_by].name }}</span></span> il {{ created | formatDateTS }}
            <span v-if="(created_by != updated_by) || (created != updated)">
                <br/>Aggiornato
                <span v-if="created_by != updated_by"> da <span class="font-bold">{{ $store.state.users[updated_by].name }}</span></span>
                <span v-if="(created != updated)"> il {{ updated | formatDateTS }}</span>
            </span>
            
        </div>
    </v-tooltip>
</template>

<script>

// data: {dialog: false, message: "", choices: [{key, val, mod}]}
export default  {
    props: {
        created: {
            type: Number,
            required: true
        },
        created_by: {
            type: String,
            default: '',
            required: true
        },
        updated: {
            type: Number,
            required: true
        },
        updated_by: {
            type: String,
            default: ',',
            required: true
        }
    },
    data(){
        return {

        }
    }
}

</script>